<template>
    <div>
        <Breadcrumbs main="matchTx.dashboard" title="" />
        <b-container fluid>   
            <div class="d-flex flex-row justify-content-start ml-5">
                <h2 class="text-dark ml-2">{{ compNameLocal }}</h2>
                <h3 class="text-primary">{{ $t('refillOL.wallet') }} :</h3>
                <h3 class="text-secondary mx-2">{{ balanced }} </h3>
                <h3 class="text-primary"> {{ $t('refillOL.mUnit') }}</h3>
                <b-button 
                    v-b-popover.hover.top="$t('homePage.refillMsg')" 
                    @click="handleClickRefillOL" 
                    class="text-dark ml-5 gradient-yg"
                    size="lg"
                    pill
                > 
                    {{ $t('refillOL.refill') }}
                </b-button>
            </div>  
            <div class="block-diagram">
              <div
                style="top: 155px; left:590px;"
                class="blockSeal"
                v-b-popover.hover.top="$t('homePage.sealAction')" 
              >
                <img :src = "require('../../assets/images/homePage/sealTag.png')" alt="Seal Image" class="block-imageSeal" />
                <!-- <p class="block-imageSeal">{{$t('homePage.sealInfo')}}</p> -->
                <button @click="handleClickSeal" class="block-button">{{$t('homePage.seal')}}</button>
              </div>  
              <div
                style="top: 35px; left:737px;"
                class="block gradient-wy"
                v-b-popover.hover.top="$t('homePage.requireAction')" 
              >
                <img :src = "require('../../assets/images/homePage/require.png')" alt="Block Image" class="block-image" />
                <p class="block-image" style="font-size: 13px;">{{ $t('homePage.requireInfo') }}</p>
                <button @click="handleClickRequire"  class="block-button btn-lg">{{ $t('homePage.require') }}</button>
              </div>
              <div
                style="top: 33px; left:900px;"
                class="blockSeal"
                v-b-popover.hover.top="$t('homePage.containerAction')" 
              >
                <img :src = "require('../../assets/images/homePage/container.png')" alt="Block Image" class="block-image my-2" />
                <p class="block-image">{{$t('homePage.containerInfo')}}</p>
                <button @click="handleClickCont" class="block-button">{{$t('homePage.container')}}</button>
              </div>
              <svg class="connecting-lines">
                  <line
                  v-for="(line, index) in linesG1"
                  :key="index"
                  :x1="line.x1"
                  :y1="line.y1"
                  :x2="line.x2"
                  :y2="line.y2"
                  :class= "line.H ? 'line' : 'lineNoArH'"
                  />
                  <defs>
                  <marker
                      id="arrowhead"
                      markerWidth="10"
                      markerHeight="7"
                      refX="9"
                      refY="3.5"
                      orient="auto"
                  >
                      <polygon points="0 0, 10 3.5, 0 7" class="arrowhead" />
                  </marker>
                  </defs>
              </svg>
            </div>
            <div class="block-diagram">
              <div
                    style="top: 60px; left:410px;"
                    class="block gradient-wb"
                    v-b-popover.hover.top="$t('homePage.bookingAction')" 
                >
                    <img :src = "require('../../assets/images/homePage/bookingID.png')" alt="Block Image" class="block-image" />
                    <p class="block-image">{{$t('homePage.bookingInfo')}}</p>
                    <button @click="handleClickBooking" class="block-button">{{$t('homePage.booking')}}</button>
                </div>
                <div
                    style="top: 50px; left:580px;"
                    class="block gradient-wy"
                    v-b-popover.hover.top="$t('homePage.reuseAction')" 
                >
                    <img :src = "require('../../assets/images/homePage/reuse.png')" alt="Reuse Image" class="block-image" />
                    <p class="block-image" style="font-size: 16px;">{{ $t('homePage.reuseInfo') }}</p>
                    <button @click="handleClickReuse" class="block-button btn-lg">{{ $t('homePage.reuse') }}</button>
                </div>  
                <div
                  style="top: 50px; left:900px;"
                  class="block gradient-wy"
                  v-b-popover.hover.top="$t('homePage.releaseAction')" 
                >
                  <img :src = "require('../../assets/images/homePage/release.png')" alt="Block Image" class="block-image" />
                  <p class="block-image" style="font-size: 13px;">{{ $t('homePage.releaseInfo') }}</p>
                  <button @click="handleClickRelease" class="block-button btn-lg">{{ $t('homePage.release') }}</button>
                </div>

                <svg class="connecting-lines">
                    <line
                    v-for="(line, index) in linesG2"
                    :key="index"
                    :x1="line.x1"
                    :y1="line.y1" 
                    :x2="line.x2"
                    :y2="line.y2"
                    :class= "line.H ? 'line' : 'lineNoArH'"
                    />
                    <!-- <defs>
                    <marker
                        id="arrowhead"
                        markerWidth="10"
                        markerHeight="7"
                        refX="9"
                        refY="3.5"
                        orient="auto"
                    >
                        <polygon points="0 0, 10 3.5, 0 7" class="arrowhead" />
                    </marker>
                    </defs> -->
                </svg>
            </div>
            <div class="block-diagram">
              <div
                  style="top: 30px; left:175px;"
                  class="blockHS6"
                  v-b-popover.hover.top="$t('getQuote.findHS6')" 
              >
              <router-link to="/info/hsCode">
                  <img :src = "require('../../assets/images/homePage/cargo.png')" alt="Cargo Image" class="block-image" />  
              </router-link>
              </div>
                <div
                    style="top: 80px; left:150px;"
                    class="block gradient-wb"
                    v-b-popover.hover.topright="$t('homePage.qReqsAction')" 
                >
                    <img :src = "require('../../assets/images/homePage/quoteReqs.png')" alt="Quote Request Image" class="block-image" />
                    <p class="text-center">{{$t('homePage.qReqsInfo')}}</p>
                    <button @click="handleClickQReqs" class="block-button"> {{$t('homePage.qReqs')}}</button>
                </div>

                <div
                    style="top: 65px; left:350px;"
                    class="blockTx gradient-wb"
                    v-b-popover.hover.top="$t('homePage.custBookingTxAction')" 
                >
                    <img :src = "require('../../assets/images/homePage/eBooking.png')" alt="Block Image" class="block-imageMatching" />
                    <p class="text-center" style="font-size: 18px;">{{ $t('homePage.custBookingTxInfo') }}</p>
                    <button @click="handleClickCustBookingTx"  class="block-button btn-lg">{{ $t('homePage.custBookingTx') }}</button>
                </div>

                <div
                    style="top: 65px; left:680px;"
                    class="blockTx gradient-wg"
                    v-b-popover.hover.top="$t('homePage.matchingAction')" 
                >
                    <img :src = "require('../../assets/images/homePage/matchingTx.png')" alt="Matching Image" class="block-imageMatching" />
                    <p class="text-center" style="font-size: 18px;">{{ $t('homePage.matchingInfo')}}</p>
                    <button @click="handleClickMatching" class="block-button btn-lg">{{ $t('homePage.matching') }}</button>
                </div>
                <div
                  style="top: 175px; left:880px;"
                  class="blockTx gradient-gw"
                >
                  <img :src = "require('../../assets/images/homePage/Ports.png')" alt="Ports Image" class="block-image" />
                </div>
                <svg class="connecting-lines">
                    <line
                    v-for="(line, index) in linesG3"
                    :key="index"
                    :x1="line.x1"
                    :y1="line.y1"
                    :x2="line.x2"
                    :y2="line.y2"
                    :class= "line.H ? 'line' : 'lineNoArH'"
                    />
                    <!-- <defs>
                    <marker 
                        id="arrowhead"
                        markerWidth="10"
                        markerHeight="7"
                        refX="9"
                        refY="3.5"
                        orient="auto"
                        
                    >
                        <polygon points="0 0, 10 3.5, 0 7" class="arrowhead" />
                    </marker>
                    </defs> -->
                </svg>
            </div>
            <div class="block-diagram">
              <div
                  style="top: 70px; left:538px;"
                  class="blockShip gradient-wo"
                  v-b-popover.hover.top="$t('homePage.shipAction')" 
              >
                  <img :src = "require('../../assets/images/homePage/shipApproval.png')" alt="Seal Image" class="block-imageShip" />
                  <p class="block-imageShipText">{{$t('homePage.shipApproval')}}</p>
              </div>
              <svg class="connecting-lines">
                  <line
                  v-for="(line, index) in linesG4"
                  :key="index"
                  :x1="line.x1"
                  :y1="line.y1" 
                  :x2="line.x2"
                  :y2="line.y2"
                  :class= "line.H ? 'line' : 'lineNoArH'"
                  />
                  <!-- <defs>
                    <marker
                        id="arrowhead"
                        markerWidth="10"
                        markerHeight="7"
                        refX="9"
                        refY="3.5"
                        orient="auto"
                    >
                        <polygon points="0 0, 10 3.5, 0 7" class="arrowhead" />
                    </marker>
                  </defs> -->
              </svg>
            </div>
        </b-container>
    </div>

  </template>

  <script>
      import {getData, getBalance } from "../../firebase"
      export default {
    data() {
      return {
        compNameLocal: '',
        balanced : 0,
        cc: '',
        linesG1: [
            { x1: 475, y1: 200, x2: 475, y2: 100 , H:false},
            { x1: 480, y1: 100, x2: 735, y2: 100, H:true}
        ],
        linesG2: [
            { x1: 475, y1: 60, x2: 475, y2: -20, H:false},
            { x1: 530, y1: 140, x2: 580, y2: 140, H:true },
            { x1: 640, y1: 10, x2: 640, y2: 50, H:true },
            { x1: 800, y1: 10, x2: 800, y2: 250, H:true },
            { x1: 960, y1: 10, x2: 960, y2: 50, H:true },
        ],
        linesG3: [
            { x1: 295, y1: 150, x2: 350, y2: 150, H:true },
            { x1: 475, y1: 70, x2: 475, y2: 30, H:true },
            { x1: 640, y1: 30, x2: 640, y2: 150, H:false},
            { x1: 640, y1: 150, x2: 680, y2: 150, H:true },            
            { x1: 800, y1: 0, x2: 800, y2: 65, H:true },
            { x1: 960, y1: 30, x2: 960, y2: 150, H:false },
            { x1: 960, y1: 150, x2: 920, y2: 150, H:true },
        ],
        linesG4: [
            { x1: 475, y1: 140, x2: 475, y2: 40, H:true },
            { x1: 540, y1: 140, x2: 475, y2: 140, H:false },    
            { x1: 735, y1: 140, x2: 800, y2: 140, H:false },
            { x1: 800, y1: 140, x2: 800, y2: 40, H:true }
          // Add more lines as needed
        ],
      };
    },
    mounted(){
        this.compId = localStorage.getItem("compId")
        getData("Company", "compId", this.compId, (res)=>{
            this.compNameLocal = res[0].compNameLocal
        })
        getBalance(this.compId ,(res)=>{
            this.balanced = res
        })
    },
    methods: {
      handleClickRefillOL() {
        this.$router.push('/payment/refillOL')
      },
      handleClickCont() {
        this.$router.push('/resource/container')
      },
      handleClickRelease() {
        this.$router.push('/process/release')
      },
      handleClickSeal() {
        this.$router.push('/resource/seal')
      },
      handleClickReuse() {
        this.$router.push('/process/reuse')
      },
      handleClickMatching() {
        this.$router.push('/dashboard/matching')
      },
      handleClickBooking() {
        this.$router.push('/resource/bookingId')
      },
      handleClickRequire() {
        this.$router.push('/process/require')
      },
      handleClickQReqs() {
        this.$router.push('/eBooking/getQuote')
      },
      handleClickCustBookingTx() {
        this.$router.push('/eBooking/custBookingTx')
      },
    },
  };
  </script>
  
  <style scoped>
  .block-diagram {
    position: relative;
    width: 100%;
    height: 190px;
  }
  
  .block {
    position: absolute;
    text-align: center;
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #f9f9f9;
  }
  .blockHS6 {
    position: absolute;
    text-align: center;
    border: 1px solid #ccc;
    background-color: #f9f9f9;
    border-radius: 300px;
  }
  .blockTx {
    position: absolute;
    text-align: center;
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 300px;
  }
  .blockShip {
    position: absolute;
    text-align: center;
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #efd250bb;
    border-radius: 30px;
  }
  .blockSeal {
    position: absolute;
    text-align: center;
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #ffffffbb;
    border-radius: 30px;
  }
  .block-image {
    width: 100px;
    height: 48px;
  }
  .block-imageSeal {
    width: 40px;
    height: 20px;

  }
  .block-imageMatching {
    width: 220px;
    height: 60px;
  }
  .block-imageShip {
    width: 180px;
    height: 80px;
  }
  .block-imageShipText {
    width: 180px;
    height: 50px;
  }
  .block-text {
    font-size: 18px;
    margin: 5px 0;
    justify-content: center;
  }
  
  .block-button {
    padding: 5px 10px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
  }
  
  .block-button:hover {
    background-color: #0056b3;
  }
  
  .connecting-lines {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  
  .line {
    stroke: #0e1cded7;
    stroke-width: 2;
    marker-end: url(#arrowhead);
    stroke-dasharray: 5, 5; /* Creates a dotted line */
    stroke-dashoffset: 10; /* Initial offset */
    animation: run-dot 1s linear infinite;
  }
  .lineNoArH {
    stroke: #0e1cded7;
    stroke-width: 2;
    stroke-dasharray: 5, 5; /* Creates a dotted line */
    stroke-dashoffset: 10; /* Initial offset */
    animation: run-dot 1s linear infinite;
  }
  .arrowhead {
    fill: #000;
  }

@keyframes run-dot {
  to {
    stroke-dashoffset: 0; /* Moves the dots along the line */
  }
}
.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-wo {
   background: linear-gradient(135deg, white, orange);
 }
 .gradient-wb {
   background: linear-gradient(135deg, white, rgb(147, 184, 235));
 }
 .gradient-wg {
   background: linear-gradient(45deg, white, rgb(6, 238, 37));
 }

 .gradient-gw {
   background: linear-gradient(45deg, rgb(6, 238, 37), white);
 }
  </style>